// extracted by mini-css-extract-plugin
module.exports = {"arrow-bounce":"CategoryPage_arrow-bounce__WxGzd","bounce":"CategoryPage_bounce__YJPXc"};